import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from '../../environments/environment';
import { UserService } from '../user/user.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class GoogleService {
  constructor(
    private http: HttpClient,
    private userService: UserService,
    private authService: AuthService,
  ) {}

  async authenticate() {
    return new Promise<any>(async res => {
      const url = await this.http.get<any>(`${env.APIUrl}/google/getUrl`).toPromise();

      window.open(url, 'googleAuth');

      (window as any).googleCallback = async code => {
        const result = await this.authService.loginWithGoogle(code);
        this.userService.cachedProfile = null;

        if (result.status === 403) {
          res(result);
          return;
        }
        await this.userService.profile();
        res(result);
      };
    });
  }
}
